import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './login.css';
import { FaEye, FaEyeSlash } from 'react-icons/fa'; // Import eye icons

const Login = () => {
    const [formData, setFormData] = useState({ emailOrMobile: '', password: '' });
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const apiUrl = process.env.NODE_ENV === 'development'
        ? process.env.REACT_APP_LOCAL_API_URL
        : process.env.REACT_APP_PRODUCTION_API_URL;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const validateInput = () => {
        const { emailOrMobile, password } = formData;

        // Regex for email, phone, and password
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const mobileRegex = /^[6-9]\d{9}$/;
        const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

        if (!emailRegex.test(emailOrMobile) && !mobileRegex.test(emailOrMobile)) {
            toast.error('Please enter a valid email or mobile number');
            return false;
        }

        if (!passwordRegex.test(password)) {
            toast.error(
                'Password must be at least 8 characters long, contain uppercase, lowercase, a number, and a special character'
            );
            return false;
        }

        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("local url:", apiUrl)
        if (!validateInput()) return;
        
        try {
            const response = await axios.post(`${apiUrl}/login`, formData, {
                withCredentials: true, // Send cookies with the request
            });

            if (response.data.success) {
                toast.success('Login successful!');
                setTimeout(() => {
                    navigate('/create-message');
                }, 3500);
            } else {
                toast.error('Login failed. Please check your credentials.');
            }
        } catch (error) {
            console.error('Error logging in:', error);
            toast.error('Error during login. Please try again later.');
        }
    };

    const handleAutoLogin = async () => {
        try {
            setLoading(true);
            
            const demoCredentials = {
                emailOrMobile: '9175366700',
                password: 'Moon@11light'
            };

            const response = await axios.post(`${apiUrl}/login`, demoCredentials, {
                withCredentials: true,
            });

            if (response.data.success) {
                toast.success('✅ Auto login successful!');
                setTimeout(() => {
                    navigate('/create-message');
                }, 2000);
            } else {
                toast.error('Auto login failed. Please try manual login.');
            }
        } catch (error) {
            console.error('Auto login error:', error);
            toast.error('Auto login failed. Please try manual login.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page-container">
            <ToastContainer autoClose={3000} />
            <div className="card login-card">
                <div className="login-header">
                    <h1>LOGIN</h1>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <input
                            className="form-input"
                            type="text"
                            name="emailOrMobile"
                            value={formData.emailOrMobile}
                            onChange={handleChange}
                            required
                            placeholder=" "
                        />
                        <label className="form-label">EMAIL OR MOBILE NUMBER</label>
                    </div>
                    <div className="form-group">
                        <input
                            className="form-input"
                            type={showPassword ? 'text' : 'password'} // Toggle input type
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            required
                            placeholder=" "
                        />
                        <label className="form-label">PASSWORD</label>
                        <span
                            className="password-toggle-icon"
                            onClick={() => setShowPassword(!showPassword)} // Toggle password visibility
                        >
                            {showPassword ? <FaEyeSlash /> : <FaEye />} {/* Toggle eye icon */}
                        </span>
                    </div>
                    <button type="submit" className="login-button">
                        LOGIN
                    </button>
                    <button 
                        type="button" 
                        className="auto-login-button"
                        onClick={handleAutoLogin}
                        disabled={loading}
                    >
                        {loading ? '⏳ Processing...' : '🚀 Auto Login (Demo)'}
                    </button>
                </form>
                <div className="auth-footer login-footer">
                    Don't have an account?
                    <Link to="/register">Register here</Link>
                </div>
                <div className="forgot-password">
                    <Link to="/forgot-password">Forgot Password?</Link>
                </div>
            </div>
        </div>
    );
};

export default Login;